const state = {
	showBuyToken: false,
	showSellEstate: false,
	showAuthenticationModal: false,
	isRegistering: false,
	isBuying: false
}

const actions = {
	
}

const mutations = {
	dismissAuthentication: () => {
		state.showAuthenticationModal = false
		state.isRegistering = false
	},

	showAuthentication: () => {
		state.showAuthenticationModal = true
	},

	showSignUpForm: (state, value) => {
		state.isRegistering = value
	},

	showBuyToken: (state, value) => {
		state.showBuyToken = value
		state.isBuying = value
	}
}

const getters = {
	isAuthenticationShown: state => state.showAuthenticationModal,
	isBuying: state => state.isBuying
}

export default {
	state,
	actions,
	mutations,
	getters
}